import Commands from './commands';

class SPop extends Commands {
    constructor(registry) {
        super("sPop", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);

        const container = this.registry.get(key);
        if (!container) {
            throw "Set not found";
        }
        return container.size === 0 ? undefined : Array.from(container)[0];
    }
}

export default SPop;
